/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {MDXWrapper} from 'lib/mdx';
import Image from 'next/image';
import ImageTabs from 'components/image-tabs';
import LanguageLinks from 'components/language-links';
import openAddOn from '../../public/how-to/1-open-addon.png';
import allowAccess from '../../public/how-to/2-allow-access.png';
import uploadFile from '../../public/how-to/3-upload-file.png';
import selectLanguage from '../../public/how-to/4-select-language.png';
import preview from '../../public/how-to/5-preview.png';
import purchase from '../../public/how-to/6-purchase.png';
import buyNow from '../../public/how-to/7-buy-now.png';
import afterPurchase from '../../public/how-to/8-after-purchase.png';
import transcribing from '../../public/how-to/9-transcribing.png';
import showTranscript from '../../public/how-to/10-show-transcript.png';
import suggestedFile from '../../public/how-to/suggested-file.png';
import lastEdit from '../../public/how-to/last-edit.png';
export const metadata = {
  title: 'Comment transcrire un audio',
  description: 'Découvrez, étape par étape, comment réaliser la transcription de tous vos fichiers audio ou vidéo grâce au module complémentaire TranscribeKit pour Google Drive',
  language: 'fr',
  availableLanguages: ['en', 'es', 'fr']
};
const MDXLayout = function Layout({children}) {
  return _jsx(MDXWrapper, {
    metadata: metadata,
    children: children
  });
};
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      em: "em",
      h2: "h2",
      a: "a",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Comment transcrire un fichier audio ou vidéo en texte ?"
      }), "\n", _jsx(LanguageLinks, {
        current: metadata.language,
        available: metadata.availableLanguages
      }), "\n", _jsxs(_components.p, {
        children: ["La transcription automatique speech-to-text utilise l’intelligence artificielle pour convertir un enregistrement audio en texte. Suivez les étapes suivantes pour retranscrire n’importe quel fichier ou vidéo en texte à l’aide du module complémentaire ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " pour ", _jsx(_components.em, {
          children: "Google Drive"
        }), "."]
      }), "\n", _jsxs(_components.h2, {
        children: ["1. Installez le module complémentaire sur ", _jsx(_components.em, {
          children: "Google Drive"
        })]
      }), "\n", _jsxs(_components.p, {
        children: [_jsx(_components.em, {
          children: "TranscribeKit"
        }), " fonctionne en tant que module complémentaire ", _jsx(_components.em, {
          children: "Google Drive"
        }), ". Vous pouvez l’installer en cliquant\n", _jsx(_components.a, {
          href: "https://workspace.google.com/marketplace/app/transcribekit/831507088910",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "ici"
        }), " pour accéder à la ", _jsx(_components.em, {
          children: "Google Marketplace"
        }), ", puis en cliquant sur le bouton ", _jsx(_components.strong, {
          children: "Install"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Une fois le module complémentaire installé, rendez-vous sur votre ", _jsx(_components.a, {
          href: "https://drive.google.com",
          target: "_blank",
          rel: "nofollow noopener noreferrer",
          children: "Google Drive"
        }), " et cliquez sur l’icône ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " qui s’affiche dans la colonne à droite."]
      }), "\n", _jsx("div", {
        className: "flex border lg:-mx-24",
        children: _jsx(Image, {
          src: openAddOn,
          alt: "Ouvrir le module complémentaire",
          quality: 100,
          placeholder: "blur",
          priority: true
        })
      }), "\n", _jsx(_components.h2, {
        children: "2. Importez votre fichier audio ou vidéo"
      }), "\n", _jsxs(_components.p, {
        children: ["Une fois le module complémentaire ouvert, sélectionnez le fichier audio ou vidéo de votre choix dans ", _jsx(_components.em, {
          children: "Google Drive"
        }), ". Ne double-cliquez pas sur le fichier car cela fera démarrer l’audio. Le module complémentaire détectera le fichier que vous avez sélectionné et un bouton ", _jsx(_components.strong, {
          children: "Allow Access"
        }), " apparaîtra. Cliquez dessus pour autoriser ", _jsx(_components.em, {
          children: "TranscribeKit"
        }), " à accéder au fichier. Un bouton ", _jsx(_components.strong, {
          children: "Upload File"
        }), " s’affichera ensuite. Cliquez dessus pour envoyer le fichier au serveur de transcription. Attendez un peu, puis cliquez sur le bouton ", _jsx(_components.strong, {
          children: "Refresh"
        }), ". L’écran suivant devrait alors s’afficher."]
      }), "\n", _jsxs(_components.p, {
        children: ["⚠ ", _jsxs(_components.em, {
          children: ["Ne cliquez pas sur les fichiers de la section ", _jsx(_components.strong, {
            children: "Suggestion"
          }), " en haut, cela ne fonctionnera pas. Pour ces fichiers, faites un clic-", _jsx(_components.strong, {
            children: "droit"
          }), " et cliquez ensuite sur ", _jsx(_components.strong, {
            children: "Afficher l’emplacement du fichier"
          })]
        })]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: suggestedFile,
            caption: 'Suggestion de fichiers'
          }, {
            image: allowAccess,
            caption: "Autoriser l'accès"
          }, {
            image: uploadFile,
            caption: 'Soumettre le fichier'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "3. Sélectionnez la langue de l’audio"
      }), "\n", _jsxs(_components.p, {
        children: ["Une fois votre fichier téléchargé, l’écran ", _jsx(_components.strong, {
          children: "New Transcript"
        }), " apparaîtra. La ", _jsx(_components.strong, {
          children: "langue de l’audio"
        }), " sélectionnée par défaut est ", _jsx(_components.em, {
          children: "English (United States)"
        }), ". Si la langue parlée dans votre enregistrement n’est pas l’anglais, veuillez sélectionner la langue correcte dans la liste."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: selectLanguage,
            alt: "Sélectionner la langue de l'audio",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "4. Demandez un aperçu des premières secondes"
      }), "\n", _jsxs(_components.p, {
        children: ["Après avoir sélectionné la langue de votre choix, cliquez sur le bouton ", _jsx(_components.strong, {
          children: "Click Here to Preview"
        }), ". Les 15 premières secondes de votre fichier audio ou vidéo seront alors retranscrites."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.em, {
          children: "Si l’aperçu n’apparaît pas, cela signifie peut-être que le début de votre enregistrement ne contient aucun son. Le module complémentaire tentera d’ignorer le silence, mais cela ne fonctionnera pas si l’audio contient des bruits de fond. Vous pourrez toujours retranscrire le fichier, mais assurez-vous avant tout d’avoir sélectionné la bonne langue."
        })
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: preview,
            alt: "Obtenir un extrait de la transcription",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "5. Achetez du temps de transcription"
      }), "\n", _jsxs(_components.p, {
        children: ["Si votre solde de temps de transcription est trop bas, le message suivant s’affichera : ", _jsxs(_components.strong, {
          children: ["\"Click HERE to purchase more transcription time at ", _jsx(_components.em, {
            children: "TranscribeKit.com"
          }), "\""]
        }), ". Cliquez sur ce lien pour accéder à votre compte sur ", _jsx(_components.em, {
          children: "TranscribeKit.com"
        }), " depuis un nouvel onglet."]
      }), "\n", _jsxs(_components.p, {
        children: ["Maintenant que vous êtes sur la page ", _jsx(_components.em, {
          children: "Account"
        }), ", cliquez sur l’un des boutons ", _jsx(_components.strong, {
          children: "Buy Now"
        }), " pour acheter 1, 5 ou 10 heures de temps de transcription. Vous pourrez payer par carte de crédit ou depuis votre compte ", _jsx(_components.em, {
          children: "PayPal"
        }), ". Les paiements sont traités par ", _jsx(_components.em, {
          children: "Paddle"
        }), " et vous recevrez une facture par e-mail."]
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["Si vous souhaitez, par exemple, acheter deux heures, cliquez sur le bouton ", _jsx(_components.strong, {
            children: "Buy Now"
          }), " pour 1 heure et sélectionnez ensuite la quantité souhaitée dans la section supérieure gauche de l’écran de paiement."]
        })
      }), "\n", _jsx(_components.p, {
        children: "Une fois le paiement finalisé, la transcription devrait apparaître automatiquement sur votre compte (cela peut prendre quelques secondes)."
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: purchase,
            caption: 'Solde insuffisant'
          }, {
            image: buyNow,
            caption: 'Page du compte'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "6. Demandez la transcription complète"
      }), "\n", _jsxs(_components.p, {
        children: ["Maintenant que vous disposez d’assez de temps de transcription, retournez sur ", _jsx(_components.em, {
          children: "Google Drive"
        }), " et cliquez sur le bouton ", _jsx(_components.strong, {
          children: "Refresh"
        }), " pour mettre à jour votre solde. Puis, cliquez sur ", _jsx(_components.strong, {
          children: "Click Here to Transcribe"
        }), ". Votre demande sera transmise au serveur de transcription."]
      }), "\n", _jsxs(_components.p, {
        children: ["⚠ ", _jsxs(_components.em, {
          children: ["Le temps de transcription sera ensuite soustrait de votre solde, donc assurez-vous d’avoir sélectionné la bonne ", _jsx(_components.strong, {
            children: "Langue de l’audio"
          }), "."]
        })]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: afterPurchase,
            alt: "Nouvelle Transcription",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "7. Attendez l’e-mail contenant votre transcription"
      }), "\n", _jsx(_components.p, {
        children: "Un écran apparaîtra ensuite pour vous informer que votre fichier est en cours de transcription. Cela devrait prendre moins d’une heure. Vous recevrez ensuite un e-mail une fois la transcription terminée. Le temps nécessaire pour réaliser la transcription peut varier en fonction de la longueur du fichier et du taux d’occupation du serveur. Il peut donc arriver que la transcription prenne un peu plus de temps."
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx("div", {
          className: "flex border w-max",
          children: _jsx(Image, {
            src: transcribing,
            alt: "Transcription en cours",
            quality: 100,
            placeholder: "blur"
          })
        })
      }), "\n", _jsx(_components.h2, {
        children: "8. Si nécessaire, apportez des corrections manuelles"
      }), "\n", _jsxs(_components.p, {
        children: ["Cliquez ensuite sur le bouton ", _jsx(_components.strong, {
          children: "Open In Google Docs"
        }), " qui figure dans l’e-mail que vous avez reçu. Cela vous redirigera vers un fichier ", _jsx(_components.em, {
          children: "Google Doc"
        }), " qui contient votre transcription complète. Vous pouvez également y accéder depuis le module complémentaire, en cliquant sur le bouton ", _jsx(_components.strong, {
          children: "Open Full Transcript"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsxs(_components.em, {
          children: ["N’hésitez pas à apporter des corrections manuelles à ce document si cela vous semble nécessaire. Si vous souhaitez ultérieurement vous référer à la version originale, il vous suffira de cliquer sur le lien ", _jsx(_components.strong, {
            children: "Dernière modification"
          }), " qui figure à côté du menu, en haut du document, pour afficher l’historique des versions."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Si vous avez accidentellement réalisé une transcription dans la mauvaise langue, cliquez sur le bouton ", _jsx(_components.strong, {
          children: "Transcribe Again"
        }), " pour réessayer. Notez toutefois que cette action déduira de nouveau du temps de transcription de votre solde."]
      }), "\n", _jsx("div", {
        className: "flex justify-center",
        children: _jsx(ImageTabs, {
          images: [{
            image: showTranscript,
            caption: 'Voir la transcription'
          }, {
            image: lastEdit,
            caption: 'Lien dernière modification'
          }]
        })
      }), "\n", _jsx(_components.h2, {
        children: "Articles sur le même sujet"
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe-zoom",
          children: "Comment transcrire l’enregistrement d’une réunion Zoom ?"
        })
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "/how-to-transcribe-google-meet",
          children: "Comment transcrire un enregistrement Google Meet ?"
        })
      })]
    });
  }
}
export default MDXContent;
